import React, { useContext } from 'react'
import {Link} from 'react-router-dom'
import Styles from './Navbar.module.css'
import { ReactComponent as Logo } from '../../assets/logo.svg'
import {RootStoreContext} from "../../_stores/rootStore";
import useTargetingPermissions from '../../pages/TargetingV2/hooks/useTargetingPermissions'
import { ExercisesContext } from '../../ExercisesContext'
import { FEATURE_BRAND_REFRESH } from '../../features'

export default function Navbar(props) {
    const rootStore = useContext(RootStoreContext);
    const { user, doLogout, isAuthenticated } = rootStore.userStore;
    const { isAdminUser, isMultiExerciseUser, isElevatedViewer } = useTargetingPermissions()
    const exercises = useContext(ExercisesContext)
    let cog = ''
    let themeToggle = ''
    let xus = ''
    let hcp = ''
    let hco = ''
    let targeting = []
    let workflow = ''

    if (isAuthenticated && user) {
        if (user.role === 'ADMIN') {
            cog = (
                <Link to='/admin' onClick={() => { if (props.location.pathname === '/admin') window.location.reload(); }}>
                    <div className={[Styles.navRightItem, props.location.pathname === '/admin' ? Styles.navRightActive : ''].join(' ')}>
                        <i className='fas fa-gear'></i>
                    </div>
                </Link>
            )
        } else {
            cog = user.IsImpersonated
                ? <div className={Styles.navRightItem}><i className='fa-solid fa-mask'></i></div>
                : ''
        }

        if (FEATURE_BRAND_REFRESH) {
            themeToggle = (
                <button
                    className={Styles.themeToggle}
                    onClick={props.toggleDarkMode}
                    title={props.darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                >
                    <i className={props.darkMode ? 'fas fa-sun' : 'fas fa-moon'}></i>
                </button>
            )
        }

        if ((user.role === 'ADMIN' || user.role === 'COMPLIANCE' || user.role !== 'ExUS') && ["81","82"].includes(user.team) == false) {
            hcp = (
                <Link to='/hcp'>
                    <li key={2} className={props.location.pathname === '/hcp' || props.location.pathname.includes('/hcp/details') ? Styles.Active : ''}
                        onClick={() => { if (props.location.pathname === '/hcp') window.location.reload(); }}>
                        <div className={Styles.Pages}>Professionals</div>
                    </li>
                </Link>
            )
        }
        if (user.role === 'ADMIN' || user.role === 'COMPLIANCE' || user.role !== 'ExUS' && ["81", "82"].includes(user.team) == false) {
            hco = (
                <Link to='/hco'>
                    <li key={3} className={props.location.pathname === '/hco' || props.location.pathname.includes('/hco/details') ? Styles.Active : ''}
                        onClick={() => { if (props.location.pathname === '/hco') window.location.reload(); }}>
                        <div className={Styles.Pages}>Organizations</div>
                    </li>
                </Link>
            )
        }
        if (user.role === 'ADMIN' || user.role === 'ExUS' || user.isExUsUser === 'true' || ["81", "82"].includes(user.team)) {
            xus = (
                <Link to='/xus'>
                    <li key={3} className={props.location.pathname === '/xus' || props.location.pathname.includes('/xus/details') ? Styles.Active : ''}
                        onClick={() => { if (props.location.pathname === '/xus') window.location.reload(); }}>
                        <div className={Styles.Pages}>Ex-US Professionals</div>
                    </li>
                </Link>
            )
        }

        if (exercises && exercises.targeting?.length > 0) {
            const useDropdown = exercises.targeting.length > 1;

            if (useDropdown) {
                const basePath = isAdminUser ? '/targeting/admin' : '/targeting';
                const anyActive = exercises.targeting.some(e =>
                    props.location.pathname.includes(`${basePath}/${e.ID}`)
                );
                targeting = (
                    <li className={[Styles.targetingDropdown, anyActive ? Styles.Active : ''].join(' ')}>
                        <div className={Styles.Pages}>
                            <i className="fas fa-bullseye"></i>&nbsp;Targeting&nbsp;
                            <i className="fas fa-chevron-down" style={{fontSize:'9px', marginLeft:'4px'}} />
                        </div>
                        <div className={Styles.dropdownMenu}>
                            {exercises.targeting.map(exercise => {
                                const path = `${basePath}/${exercise.ID}`;
                                const isActive = props.location.pathname.includes(path);
                                return (
                                    <Link key={exercise.ID} to={path}>
                                        <div
                                            className={[Styles.dropdownItem, isActive ? Styles.dropdownItemActive : ''].join(' ')}
                                            onClick={() => { if (props.location.pathname.includes(path)) window.location.reload(); }}
                                        >
                                            <i className="fas fa-bullseye" style={{marginRight:'8px', fontSize:'11px', opacity:0.7}} />
                                            {exercise.NAME}
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    </li>
                );
            } else if (isAdminUser) {
                targeting = (
                    <Link key={exercises.targeting[0].ID} to={`/targeting/admin/${exercises.targeting[0].ID}`}>
                        <li className={props.location.pathname.includes(`/targeting/admin/${exercises.targeting[0].ID}`) ? Styles.Active : ''}
                            onClick={() => { if (props.location.pathname.includes(`/targeting/admin/${exercises.targeting[0].ID}`)) window.location.reload(); }}>
                            <div className={Styles.Pages}><i className="fas fa-bullseye"></i>&nbsp;{exercises.targeting[0].NAME}</div>
                        </li>
                    </Link>
                );
            } else {
                // Elevated viewers (OBD etc) land on the admin summary panel; plain reps go directly to their exercise
                const singleTargetPath = isElevatedViewer ? '/targeting' : `/targeting/${exercises.targeting[0].ID}`;
                targeting = (
                    <Link to={singleTargetPath}>
                        <li className={props.location.pathname.includes('/targeting') ? Styles.Active : ''}
                            onClick={() => { if (props.location.pathname.includes('/targeting')) window.location.reload(); }}>
                            <div className={Styles.Pages}><i className="fas fa-bullseye"></i>&nbsp;{exercises.targeting[0].NAME}</div>
                        </li>
                    </Link>
                );
            }
        }

        var workflowEnabledForRoles = ['OCNE', 'ADMIN', 'OHS', 'OBD', 'DTS', 'DBD', 'ITS', 'IDD', 'ASD', 'ABD', 'VP'];
        if ((workflowEnabledForRoles.includes(user.role) ||
               user.IsHemoncComp == "true" || user.IsDermComp == "true" ||
               user.IsDermOps == "true"   || user.IsHemoncOps == "true" ||
               user.IsEDAdmin == "true"   || user.IsMarketAccessRole == "true") &&
            ["81", "82"].includes(user.team) == false) {
            workflow = (
                <Link to='/workflow'>
                    <li key={4} onClick={() => { if (props.location.pathname === '/workflow') window.location.reload(); }}>
                        <div className={Styles.Pages}>Exhibits &amp; Displays</div>
                    </li>
                </Link>
            )
        } else {
            workflow = '';
        }
    }

    return (
        !isAuthenticated && !user ? <div></div> :
        <div className={Styles.NavBar}>

            {/* ── Left: logo + nav links ──────────────────────────────── */}
            <div className={Styles.navLeft}>
                <div className={Styles.Wrapper}>
                    <Logo className={Styles.Logo} aria-label="Incyte MDM Portal" />
                </div>
                <ul className={Styles.navLinks}>
                    <Link to='/'>
                        <li key={1} className={props.location.pathname === '/' ? Styles.Active : ''}
                            onClick={() => { if (props.location.pathname === '/') window.location.reload(); }}>
                            <div className={Styles.Pages}>Home</div>
                        </li>
                    </Link>
                    {hcp}
                    {hco}
                    {xus}
                    {targeting}
                    {workflow}
                </ul>
            </div>

            {/* ── Right: user chrome — never clips ────────────────────── */}
            <div className={Styles.navRight}>
                <span className={Styles.username}>{user.userName}</span>
                {cog}
                {themeToggle}
                <span className={Styles.logoutBtn}
                    onClick={() => {
                        let callback = window.location.href = '/authentication/logout';
                        doLogout(callback);
                    }}
                >Logout</span>
            </div>

        </div>
    )
}
